import { makeStyles, tokens } from "@fluentui/react-components";
import { flexParent, flexParentCenterCrossAxis } from "../utilities/Mixin.styles";
/**
 * Griffel styles for the container element
 */ const containerStyle = {
    ...flexParent("column"),
    ...flexParentCenterCrossAxis,
    justifyContent: "center"
};
/**
 * Griffel styles for centering content
 */ const centerContentStyle = {
    ...flexParent("column"),
    ...flexParentCenterCrossAxis,
    justifyContent: "center",
    flex: "1"
};
/**
 * Griffel styles for spinner wrapper
 */ const spinnerWrapperStyle = {
    ...flexParent("column"),
    ...flexParentCenterCrossAxis,
    gap: tokens.spacingVerticalM
};
/**
 * Get the react hook that returns the classnames associated with the computed styles
 */ export const useStyles = makeStyles({
    containerStyle,
    centerContentStyle,
    spinnerWrapperStyle
});
/**
 * Custom styles for the primary view spinners to ensure they take the full height of the viewport
 */ export const useFullscreenSpinnerStyles = makeStyles({
    containerStyle: {
        height: "100vh"
    }
});
